package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository
import kotlinx.coroutines.flow.Flow

class GetTodayAppointmentsUseCase(
    private val repository: AppointmentRepository
) {
    operator fun invoke(): Flow<List<Appointment>> {
        return repository.getTodayAppointments()
    }
}
